@import '../../theme/colors';
@import '../../theme/mixins';

.report {
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & > div:last-child {
    flex-grow: 1;
  }

  .fullscreenContainer {
    // darkened to allow scrollbar visibility
    background-color: #c1c1c1;
  }

  button {
    color: $oceanBlue;
    &:hover {
      background-color: #d8d8d8;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .rightHeader {
    display: flex;
    align-items: center;
    font-family: var(--font-family__body);
    font-size: 12px;

    .headerText {
      margin: 0 6px;
    }

    .date {
      font-weight: 400;
    }
  }

  .tooltipLine {
    @extend .rightHeader;
    display: flex;
    justify-content: space-between;
  }
}

.loading {
  position: fixed;
  top: 50%;
  left: 55%;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid $lightGrey;
  background-color: $white;

  .leftTools,
  .rightTools {
    display: flex;
    align-items: center;
    position: relative;
  }

  .leftTools button {
    margin-right: 9px;
  }

  .rightTools button {
    margin-left: 9px;
  }

  .exportButtons {
    position: relative;
    display: flex;
    align-items: center;
    left: 1px;
    /* button icons */
    button > span {
      position: relative;
      left: -3px;
    }
    .dropdown {
      position: absolute;
      left: 16px;
      font-size: 16px;
      color: #595959;
    }
  }

  .help {
    color: $oceanBlue;
    font-size: 22px;
  }
}

.toolbarFullscreen {
  @extend .toolbar;
  padding: 0 25px;
}

.exportMenu {
  padding: 0;

  .menuItem {
    min-height: 31px;
    font-size: 14px;
    padding: 0 13px;
  }

  .menuItem:hover {
    background-color: $iceBlue;
  }
}

.viewsModal {
  display: flex;
  align-items: center;
  justify-content: center;

  .modalHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .close {
      cursor: pointer;
      color: $oceanBlue;
    }
  }

  .circularProgressContainer,
  .loadErrorContainer {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loadError {
    @include label2;
    text-align: center;
  }

  .outerContainer {
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.7);
    height: 400px;
    outline: none;
    overflow: hidden;
    padding: 20px;
    padding-bottom: 50px;
    width: 440px;
    margin: auto;

    .manageTitle {
      @include h3;
      display: block;
      padding-bottom: 4px;
      margin-bottom: 6px;
      border-bottom: 1px solid $lightGrey;
    }

    .manageButton {
      width: 96px;
      margin-top: 6px;
      height: 30px;
      border-radius: 2px;
      padding-top: 0;
      padding-bottom: 0;
      color: white;
      cursor: pointer;
      background-color: $secondaryBlue;
      position: absolute;
      bottom: 12px;
      right: 20px;
    }

    .manageButton:hover {
      background-color: $oceanBlue;
    }

    .manageButton:active {
      background-color: $seconaryActive;
    }

    .disabledManageButton {
      @extend .manageButton;
      background-color: $lightGrey;
    }

    .checkboxForm {
      padding-bottom: 6px;
      border-bottom: 1px solid $lightGrey;
      margin-bottom: 10px;
    }

    .checkbox {
      height: 16px;
      width: 16px;
      border-radius: 3px;
      border: 1px solid $neutral-300;
      color: transparent !important;
      background-color: transparent;
      padding: 0;
      margin-right: 6px;
      box-sizing: border-box;

      path {
        color: transparent;
      }
    }

    .checkbox:hover {
      border: 1px solid $seconaryActive;
    }

    .checkboxActive {
      @extend .checkbox;

      svg {
        width: 20px;
        height: 20px;
      }

      path {
        color: $oceanBlue;
      }
    }

    .checked {
      margin-right: 40px;
      margin-left: 0;

      span {
        @include body2;
      }
    }

    .viewNameForm {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .viewNameInput {
        margin: 0;
        margin-top: 6px;
        width: 318px;
        padding: 0;
      }

      .submitButton {
        width: 96px;
        margin-top: 6px;
        height: 30px;
        border-radius: 2px;
        padding-top: 0;
        padding-bottom: 0;
        color: white;
        cursor: pointer;
        background-color: $secondaryBlue;
      }

      .submitButton:hover {
        background-color: $oceanBlue;
      }

      .submitButton:active {
        background-color: $seconaryActive;
      }

      .disabledSubmit {
        @extend .submitButton;
        background-color: $lightGrey;
      }
    }

    .manageCustomContainer {
      height: 45%;
      & > div:first-child {
        & > div {
          display: flex;
          flex-direction: column;
        }
      }

      .manageScroll {
        height: calc(100% - 38px) !important;
        & > div:first-child {
          position: relative !important;
          height: 100%;
          overflow: auto !important;
        }
      }

      .manageOtherScroll {
        @extend .manageScroll;
      }

      .viewName {
        @include label1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: none;
        outline: none;
        min-height: 23px;
        line-height: 23px;
        padding: 0 25px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        i {
          position: absolute;
          font-size: 16px;
          left: 3px;
          cursor: pointer;
        }

        svg {
          cursor: pointer;
        }

        input {
          width: 95%;
          border: 1px solid black;
          outline: none;
        }

        .closeIcon {
          position: relative;
          margin-right: 2px;
        }
      }

      .viewName:hover {
        background-color: #f5f5f5;
      }

      .activeView {
        @extend .viewName;
        background-color: $lightGrey;
      }

      .viewManage {
        @extend .viewName;
        cursor: inherit;
      }

      .viewManage:hover {
        cursor: inherit;
      }

      .viewManageDefault {
        @extend .activeView;
        @extend .viewManage;
      }

      .activeView:hover {
        background-color: $lightGrey;
      }

      .editingContainer {
        padding-left: 5px;
      }

      .myViewName {
        display: flex;
        align-items: center;
        padding-left: -20px;
        width: 70%;
        max-width: 70%;

        span {
          max-width: 98%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .otherViewName {
        @extend .myViewName;
        max-width: 50%;
      }

      .manageMyViewName {
        max-width: 70%;
        display: flex;
        align-items: center;
      }

      .manageOtherViewName {
        @extend .myViewName;
        max-width: 50%;
      }

      .manageMyViewActions {
        display: flex;
        align-items: center;

        i {
          position: relative;
          margin-right: 5px;
        }

        svg {
          display: flex;
        }
      }

      .otherViewOwner {
        max-width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .customViews {
      height: calc(50% - 72px);
      .viewsContainer {
        height: calc(100% - 24px);
        @extend .manageCustomContainer;
      }
    }

    .otherViews {
      @extend .customViews;
      height: calc(50% - 72px);
    }
  }
}

.dialog {
  .container {
    height: 132px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .confirmationHeader {
    margin-bottom: 15px;
  }

  .buttonContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .confirmButton {
    width: 96px;
    height: 24px;
    border-radius: 2px;
    padding-top: 0;
    margin-left: 38px;
    padding-bottom: 0;
    color: white;
    cursor: pointer;
    background-color: $secondaryBlue;
  }

  .confirmButton:hover {
    background-color: $oceanBlue;
  }

  .confirmButton:active {
    background-color: $seconaryActive;
  }
}

.altTextScrolling {
  height: min-content !important;

  & > div:first-child {
    position: relative !important;
    min-height: min-content;
    max-height: 80vh;
  }
}
